import { vendorDoctorAdapter } from './reducer'

export const { selectAll: selectAllVendorDoctors, selectById: selectVendorDoctorById } =
  vendorDoctorAdapter.getSelectors(state => state.vendorDoctors)
